import { useState, useEffect } from 'react';
import { navLinks, heroContent, logos } from '../data/mock';
import { Button } from './ui/button';
import { Menu, Phone, X } from 'lucide-react';

export const Header = ({ onBookDemo }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const sectionId = href.replace('#', '');
    if (sectionId === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${
        scrolled
          ? 'bg-[#0A1628]/95 backdrop-blur-xl shadow-2xl shadow-black/20'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#home"
            onClick={(e) => handleNavClick(e, '#home')}
            className="flex items-center gap-2.5 group"
          >
            <img
              src={logos.iconOnly}
              alt="Chris IELTS"
              className="w-11 h-11 rounded-lg object-contain group-hover:scale-105 transition-transform duration-300"
            />
            <div className="hidden sm:block">
              <span className="text-white font-bold text-lg" style={{ fontFamily: 'Poppins, sans-serif' }}>Chris</span>
              <span className="text-[#E8C87A] font-bold text-lg ml-1" style={{ fontFamily: 'Poppins, sans-serif' }}>IELTS</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden xl:flex items-center gap-6">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-white/70 hover:text-[#E8C87A] transition-colors duration-300 text-[13px] font-medium tracking-wide"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden xl:flex items-center gap-3">
            <a
              href={`tel:+${heroContent.whatsappNumber}`}
              className="text-white/70 hover:text-[#E8C87A] transition-colors duration-300"
            >
              <Phone className="w-4 h-4" />
            </a>
            <Button
              onClick={onBookDemo}
              className="bg-[#D4A853] hover:bg-[#C9A84C] text-[#0A1628] font-semibold px-5 py-2 text-sm rounded-full shadow-lg shadow-[#D4A853]/20 hover:shadow-[#D4A853]/40 transition-[background-color,box-shadow] duration-300"
            >
              Book Free Demo
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="xl:hidden text-white p-2 hover:bg-white/10 rounded-lg transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileOpen && (
        <div className="xl:hidden bg-[#0A1628]/98 backdrop-blur-xl border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-white/80 hover:text-[#E8C87A] hover:bg-white/5 transition-colors duration-300 text-base font-medium py-3 px-4 rounded-xl"
              >
                {link.label}
              </a>
            ))}
            <div className="mt-3 px-4 pb-2">
              <Button
                onClick={() => { setMobileOpen(false); onBookDemo?.(); }}
                className="bg-[#D4A853] hover:bg-[#C9A84C] text-[#0A1628] font-semibold w-full rounded-full"
              >
                Book Free Demo
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
